<script setup lang="ts">
import LoadingSpinner from "@comp-lib/components/LoadingSpinner.vue";
import JumpingBeads from "@comp-lib/components/JumpingBeads.vue";
import { computed } from "vue";

const props = defineProps<{
  longLoad?: boolean;
  message?: string;
}>();

const loadingMessage = computed(() => {
  if (props.message) return props.message;
  return props.longLoad ? "Hang tight, your data is being processed..." : "Loading...";
});
</script>

<template>
  <div class="loading">
    <template v-if="props.longLoad">
      <JumpingBeads />
      <p>{{ loadingMessage }}</p>
    </template>

    <template v-else>
      <LoadingSpinner />
      <template v-if="props.message">{{ loadingMessage }}</template>
    </template>
  </div>
</template>

<style scoped lang="scss">
.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  height: 100%;
  font-weight: 600;
  color: map.get(v.$gray, "400");
}
</style>
